<template>
<div>
  <MembershipType v-if="state.appStage.currentProgress === 'lookup'"></MembershipType>
  <Application v-if="state.appStage.currentProgress === 'app'"></Application>
</div>
</template>

<script>

import {mapGetters} from 'vuex'
import Application from './Application'
import MembershipType from "./MembershipType";

export default {
  name: "Form",
  computed: {
    ...mapGetters({
      state: 'getState',
    }),
  },
  components:{
    Application,
    MembershipType,
  }
}
</script>

<style scoped>

</style>